import { StatusChangeDialogs } from "@jobs/candidate-sheet-v2/status-change-dialogs/StatusChangeDialogs";

import { CandidacyStatus } from "@/types";

// Hosts the status-change dialogs for a kanban chip selection. The pipeline
// wraps this in SheetScopeProvider, which the dialogs resolve the candidacy from.
export const KanbanStatusChipDialogHost = ({
  onClose,
  onStatusChanged,
  status,
}: {
  onClose: () => void;
  onStatusChanged: (status: CandidacyStatus) => void;
  status: CandidacyStatus;
}) => {
  return (
    <StatusChangeDialogs
      onStatusChanged={onStatusChanged}
      openStatusChangeDialog={status}
      setOpenStatusChangeDialog={(next) => {
        if (!next) onClose();
      }}
    />
  );
};
